import {createApi} from "@reduxjs/toolkit/query/react"
import {IBasicResponse} from "../../types/api"
import baseQuery from "../../utils/apiIIKOConfig"
import {IGetPaymentTypesParams, IPaymentType, IUpdatePaymentTypeParams} from "./PaymentTypeApiTypes"

export const paymentTypeApi = createApi({
    reducerPath: "paymentTypeApi",
    baseQuery,
    tagTypes: ["payment-types"],
    endpoints: (build) => ({
        getPaymentTypes: build.query<IBasicResponse<IPaymentType[]>, IGetPaymentTypesParams | void>({
            query: (params) => ({
                url: "/v1/payment-types/list",
                method: "GET",
                params: params?.branchId ? {branchId: params.branchId} : undefined
            }),
            providesTags: ["payment-types"]
        }),
        updatePaymentTypeById: build.mutation<IBasicResponse<void>, IUpdatePaymentTypeParams>({
            query: ({id, name, processesExternally, comment, hidden}) => ({
                url: `/v1/payment-types/${id}`,
                method: "PATCH",
                body: {
                    name,
                    processes_externally: processesExternally,
                    comment: comment ?? undefined,
                    hidden
                }
            }),
            invalidatesTags: ["payment-types"]
        })
    })
})

export const {
    useGetPaymentTypesQuery,
    useUpdatePaymentTypeByIdMutation
} = paymentTypeApi
